import Heading from "../../Heading";
import LinkComponent from "../../LinkComponent";

import * as styles from "./styles.module.scss";

export function RichTextReferences({
  title,
  list,
}: Partial<ReferencesListComponent>) {
  return (
    <div className={styles.references}>
      <Heading level={3}>{title}</Heading>
      {Array.isArray(list) && (
        <ol className={styles.referencesList}>
          {list.map(
            (reference) =>
              reference?.element[0] && (
                <li id={reference.anchor} key={reference.anchor}>
                  {reference.element[0].component === "element_link" ? (
                    <LinkComponent
                      type="internal"
                      url={reference.element[0].url}
                    >
                      {reference.element[0].title}
                    </LinkComponent>
                  ) : (
                    <p>{reference.element[0].text}</p>
                  )}
                </li>
              )
          )}
        </ol>
      )}
    </div>
  );
}
